<template>
  <div class="about-us-features">
    <p class="about-us-features__title">
      At OStado
    </p>
    <div class="about-us-features__items">
      <div v-for="item in features" class="features-items">
        <div>
          <img
            :data-src="item.icon"
            width="160"
            height="160"
            class="lazyload mx-auto w-[128px] lg:w-[160px]"
            alt="features"
          >
        </div>
        <p class="text__headline-4-xs--semibold lg:text__headline-5-md--semibold text-title text-center mt-4 lg:mt-8 mb-3">
          {{ item.title }}
        </p>
        <p class="text__headline-5-xs--regular lg:text__body-3-md--regular text-body-1">
          {{ item.content }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import staticData from './static-data'
export default {
  name: 'AboutUsFeatures',
  data () {
    return {
      ...staticData
    }
  }
}
</script>

<style scoped lang="scss">
.about-us-features {
  @apply container;
  &__title {
    @apply text__headline-3-xs--bold lg:text__headline-3-md--bold text-center mb-8;
  }
  &__items {
    @apply flex flex-col lg:flex-row justify-between lg:space-x-6 space-y-6 lg:space-y-0;
    .features-items {
      @apply bg-bg-cart px-4 py-12 rounded-b-2xl rounded-t-[64px];
    }
  }
}
</style>
